import React from "react";
import { Link } from "react-router-dom";
import { blogData } from "../data/data";

import { FiCalendar, FiClock, FiArrowRight } from '../assets/icons/icons'

export default function Blog(){
    return(
        <div className="row">
            {blogData.slice(0,3).map((item, index) =>{
                return(
                    <div className="col-lg-4 col-md-6 mt-4 pt-2" key={index}>
                        <div className="card blog blog-primary border-0 shadow rounded overflow-hidden">
                            <div className="position-relative overflow-hidden">
                                <img src={item.image} className="img-fluid" alt=""/>
                                <Link to="#" className="tag py-1 px-4 d-inline-block h6 mb-0 text-white rounded-lg">{item.tag}</Link>
                            </div>
                            <div className="card-body p-4">
                                <ul className="list-unstyled mb-2">
                                    <li className="list-inline-item text-muted small me-3 d-inline-flex align-items-center"><FiCalendar className="text-dark h6 me-1 mb-0"/>{item.date}</li>
                                    <li className="list-inline-item text-muted small d-inline-flex align-items-center"><FiClock className="text-dark h6 me-1 mb-0"/>{item.time}</li>
                                </ul>
                                <Link to="#" className="text-dark title h5">{item.title}</Link>
                                
                                <div className="mt-2">
                                    <Link to="#" className="link">Read more <FiArrowRight className="fea icon-sm"/></Link>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            })}
        </div>
    )
}